import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as WerkNLIcon } from './werkNL.svg';

export const WerkNL = IconHOC(WerkNLIcon);
